import * as taskName from './task-name'
import {createUIDefinition} from '../default-task-definition'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'

export default createUIDefinition({
    taskName: taskName.VISUALIZATION_CHECK,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.TREATMENT_VISUALIZATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.QUOTATION_CUSTOMER_LOADED,
            taskPath: ['objectDetail', 'customer'],
        },
    ],

})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/visualization-check.js